/**
 * Tiny holder for the global refreshData callback.
 * Avoids polluting `window` and eliminates `(window as any).__refreshData`.
 * main.ts registers the implementation at startup; panels import and call it.
 */

let _refreshFn: ((forceRefresh?: boolean) => Promise<void>) | null = null;

export function setRefreshFn(fn: (forceRefresh?: boolean) => Promise<void>): void {
  _refreshFn = fn;
}

export async function triggerRefresh(forceRefresh = false): Promise<void> {
  if (_refreshFn) await _refreshFn(forceRefresh);
}
